import { useState } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
//components

//primereact
import { Button } from "primereact/button";
import { BreadCrumb } from "primereact/breadcrumb";
import { confirmDialog } from "primereact/confirmdialog";
import { formatDate } from "../../../utils/formatDate";
import { formatCurrency } from "../../../utils/formatCurrency";
import { postReverseInstallment } from "../../../services/Report/postReverseInstallment";
import FiltersReversalOfInstallments from "./FiltersReversalOfInstallments";
import Panel from "../../../components/panel/panel";
import { Table } from "../../Financial/ReversalReport/Table";
import { getReportReverseInstallment } from "../../../services/Report/getReportReverseInstallment";
import { useAppContext } from "../../../context/AppContext";
import usePermission from "../../../hooks/usePermission";
import { Paginator } from "primereact/paginator";

//services

export default function ReversalReport() {
  usePermission("123"); //Visualizar Parcelas Estornadas
  const { permissions } = useAppContext();
  const [lastData, setLastData] = useState();
  const [table, setTable] = useState();
  const [visible, setVisible] = useState(false);
  const [itemsSelected, setItemsSelected] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [savedDataTable, setSavedDataTable] = useState(null);
  const [filter, setFilter] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const items = [
    {
      template: () => (
        <Link
          to={"/financial/reversalReport"}
          className="p-breadcrumb-link"
        >
          Estorno de Parcelas
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/dashboard"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  }

  // const onGlobalFilterChange = (e) => {
  //   setGlobalFilterValue(e.target.value);
  // };

  const columns = [
    { field: "id", header: `Código` },
    { field: "sequence_number", header: `N° Parcela` },
    {
      field: "client",
      header: `Cliente`,
    },
    {
      field: "desc",
      header: "Descrição",
    },
    {
      field: "enterprise",
      header: "Empreendimento",
    },
    {
      field: "status",
      header: "Situação",
      body: (rowData) => {
        let labelClass = "";
        let labelText = "";
        switch (rowData.status) {
          case 0:
            labelClass = "badge bg-warning";
            labelText = "A Vencer";
            break;
          case 1:
            labelClass = "badge bg-success";
            labelText = "Pago";
            break;
          case 2:
            labelClass = "badge bg-success";
            labelText = "todos";
            break;
          default:
        }
        return (
          <span
            className={labelClass}
            style={{
              fontSize: "10px",
            }}
          >
            {labelText}
          </span>
        );
      },
    },
    {
      field: "local",
      header: "Q/L",
    },
    {
      field: "due_date",
      header: "Data de Vencimento",
      body: (rowData) => rowData.due_date && formatDate(rowData.due_date),
    },
    {
      field: "value",
      header: "Valor Parcela",
      body: (rowData) => rowData.value && formatCurrency(rowData.value),
    },
    {
      field: "payment_date",
      header: "Data Recebimento",
      body: (rowData) =>
        rowData.payment_date && formatDate(rowData.payment_date),
    },
    {
      field: "discount",
      header: "Desconto",
    },
    {
      field: "fine",
      header: "Acréscimo",
    },
    {
      field: "payment_method",
      header: "Forma de Pagamento",
    },
    {
      field: "released_by",
      header: "Lançado por",
    },
    {
      field: "completed_by",
      header: "Baixado por",
    },
  ];



  const handlePageChange = async (event) => {
    // console.log(filter)
    setLoadingButton(true)
    setFirst(event.first);
    setRows(event.rows);
    setIsLoading(true)
    const notification = toast.loading("Buscando..");
    try {
      const response = await getReportReverseInstallment(filter, event.page + 1);

      const obj = response.data.map((row) => ({
        ...row,
        block: row.block + " / " + row.land,
      }));

      setTable(obj);
      setSavedDataTable(obj);

      const totalRecords = response.last_page * response.per_page;
      setTotalRecords(totalRecords);
      setCurrentPage(response.current_page);

      toast.update(notification, {
        render: "Consulta realizada com sucesso",
        type: "success",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Falha ao realizar consulta!",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
    finally {
      setIsLoading(false)
      setLoadingButton(false)
    }
  };

  const acceptInstallments = async (parcels) => {
    setLoadingButton(true)
    const notification = toast.loading("Por favor aguarde...");
    const data = {};
    data.installments = [];
    parcels.map((p) => data.installments.push(p.id));
    try {
      await postReverseInstallment(data);
      const response = await getReportReverseInstallment(filter, 1);

      const obj = response.data.map((row) => ({
        ...row,
        block: row.block + " / " + row.land,
      }));

      setTable(obj);
      toast.update(notification, {
        render: "Ação efetuada com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });

    } catch (e) {
      toast.update(notification, {
        render: "Não Possível Desfazer o Estorno!",
        autoClose: 2000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
    finally {
      setItemsSelected([]);
      setLoadingButton(false)
    }
  };

  const handleInstallments = () => {
    confirmDialog({
      message: "Deseja desfazer o estorno?",
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => acceptInstallments(itemsSelected),
    });
  };

  return (
    <>
      <div className="row d-flex justify-content-between mb-3">
        <div className="col-xl-4 col-md-6">
          <BreadCrumb
            model={items}
            home={home}
            style={{
              background: "transparent",
              border: "none",
              fontSize: "16px",
            }}
          />
        </div>
        <div className="col-xl-8 col-md-6">
          <div className="row justify-content-end pb-3">
            {permissions && permissions.includes("50") && ( // Desfazer Estorno de Parcelas
              <div className="col-xl-4">
                <Button
                  loading={loadingButton}
                  rounded
                  icon="fa fa-undo"
                  severity="warning"
                  disabled={itemsSelected.length === 0}
                  label="Desfazer Estorno"
                  onClick={() => handleInstallments()}
                  className="p-inputtext-sm me-2 m-auto w-100"
                />
              </div>
            )}
          </div>
        </div>
        <Panel title="Estorno de Parcelas">
          <FiltersReversalOfInstallments
            setLastData={setLastData}
            setTable={setTable}
            setVisible={setVisible}
            currentPage={currentPage}
            filter={filter}
            setFilter={setFilter}
            setTotalRecords={setTotalRecords}
            totalRecords={totalRecords}
            setCurrentPage={setCurrentPage}
            setFirst={setFirst}
            setSavedDataTable={setSavedDataTable}
            setRows={setRows}
          />
        </Panel>

        {visible && (
          <>
            <Table
              setLastData={setLastData}
              setTable={setTable}
              table={table}
              setVisible={setVisible}
              setItemsSelected={setItemsSelected}
              itemsSelected={itemsSelected}
              isLoading={isLoading}
            />
            <Paginator
              first={first}
              rows={rows}
              totalRecords={totalRecords}
              onPageChange={handlePageChange}
              template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            />
          </>
        )}
      </div>
    </>
  );
}
